import { render, staticRenderFns } from "./NewChoreMenu.vue?vue&type=template&id=dc46eb18&scoped=true"
import script from "./NewChoreMenu.vue?vue&type=script&lang=js"
export * from "./NewChoreMenu.vue?vue&type=script&lang=js"
import style0 from "./NewChoreMenu.vue?vue&type=style&index=0&id=dc46eb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc46eb18",
  null
  
)

export default component.exports